import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, V2ShareFacebookIcon } from '@paypalcorp/pp-react';

function SocialShareFacebook({ url, handleSocialLinkClick, linkTitle }) {
  return (
    <IconButton
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'facebook')}
      data-testid="social-share-facebook"
      size="sm"
      buttonType="secondary"
      svgIconComponent={V2ShareFacebookIcon}
    >
      {linkTitle}
    </IconButton>
  );
}

SocialShareFacebook.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
  linkTitle: PropTypes.string,
};

export default SocialShareFacebook;
